import { render, staticRenderFns } from "./PhonelinkOffOutlined.vue?vue&type=template&id=4cad1997&"
import script from "./PhonelinkOffOutlined.vue?vue&type=script&lang=js&"
export * from "./PhonelinkOffOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports